import React from 'react';
import { PageHero } from '../components/PageHero';
import { SectionHeading } from '../components/SectionHeading';
import { ProductCard } from '../components/shop/ProductCard';
import { images } from '../data/images';
import { products } from '../data/products';
export function Shop() {
  const online = products.filter(p => !p.inHouse);
  const inHouse = products.filter(p => p.inHouse);
  return <>
      <PageHero title="Shop" subtitle="Merch, deposits & gift certificates" image={images.shirt} data-id="element-517" data-mp="34ax59ppmsntt" />
      <section className="mx-auto max-w-6xl px-6 py-20" aria-label="Shop products" data-id="element-518" data-mp="2zbtyo0u069jq">
        <div className="grid gap-x-6 gap-y-14 sm:grid-cols-2 lg:grid-cols-3" data-id="element-519" data-mp="3dzyjpbgj2x5o">
          {online.map(product => <ProductCard key={product.slug} product={product} data-id="element-520" data-mp="3986r6vdtahcw" />)}
        </div>
      </section>
      <section className="border-t border-ink-line py-20" data-id="element-521" data-mp="2li2yhj25w20o">
        <div className="mx-auto max-w-6xl px-6" data-id="element-522" data-mp="2gkkmfjsul6og">
          <SectionHeading title="In-House Products" text="Available at the shop. Stop by Trip Ink Tattoo Company to pick them up." data-id="element-523" data-mp="2gjrnv641lnhe" />
          <div className="mt-12 grid gap-x-6 gap-y-14 sm:grid-cols-2 lg:grid-cols-3" data-id="element-524" data-mp="3ijeliooqnwjx">
            {inHouse.map(product => <ProductCard key={product.slug} product={product} data-id="element-525" data-mp="3n9ux0390183n" />)}
          </div>
        </div>
      </section>
    </>;
}